import { useMemo } from 'react';

type Env = {
  supabaseUrl?: string;
  supabasePublishableKey?: string;
  /** @deprecated Compatibility alias. */
  supabaseAnonKey?: string;
  isSupabaseConfigured: boolean;
};

export function useEnv(): Env {
  // Vite exposes env vars via import.meta.env at build/runtime
  // We read them safely and compute a single readiness flag.
  return useMemo(() => {
    const viteEnv = import.meta.env;
    const supabaseUrl = viteEnv.VITE_SUPABASE_URL;
    const supabasePublishableKey = (
      viteEnv.VITE_SUPABASE_PUBLISHABLE_KEY
      || viteEnv.VITE_SUPABASE_ANON_KEY
    );

    const hasUrl = typeof supabaseUrl === 'string' && supabaseUrl.trim().length > 0;
    const hasKey = typeof supabasePublishableKey === 'string' && supabasePublishableKey.trim().length > 0;

    return {
      supabaseUrl: hasUrl ? supabaseUrl : undefined,
      supabasePublishableKey: hasKey ? supabasePublishableKey : undefined,
      supabaseAnonKey: hasKey ? supabasePublishableKey : undefined,
      isSupabaseConfigured: hasUrl && hasKey,
    };
  }, []);
}
